// video in content blocks -- handle aspect ratios
// document.addEventListener('DOMContentLoaded', function () {
//   const iframes = document.querySelectorAll('.content-flow iframe')
//   const videos = document.querySelectorAll('.content-flow video')

//   iframes.forEach(function (iframe) {
//     if (iframe.src.includes('youtube.com') || iframe.src.includes('vimeo.com')) {
//       let videoContainer = document.createElement('div')
//       videoContainer.classList.add('video-container')

//       iframe.parentNode.insertBefore(videoContainer, iframe)
//       videoContainer.appendChild(iframe)
//     }
//   })

//   videos.forEach(function (vid) {
//     let videoContainer = document.createElement('div')
//     videoContainer.classList.add('video-container')
//     vid.parentNode.insertBefore(videoContainer, vid)
//     videoContainer.appendChild(vid)
//   })
// })

// video in media / text blocks
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.media-content').forEach((container, index) => {
    const video = container.querySelector('video')

    if (video) {
      // ensure each video has a unique ID for the aria-controls
      if (!video.id) {
        video.id = `video-${index + 1}`
      }

      // create a pause/play toggle button
      const btn = document.createElement('button')
      btn.className = 'btn-media-toggle'
      btn.innerHTML = '<span aria-hidden="true" class="szicon-pause-button"></span>'
      btn.setAttribute('aria-controls', video.id)
      btn.setAttribute('aria-pressed', 'false') // play the video on load
      btn.setAttribute('aria-label', 'Pause video')

      btn.addEventListener('click', () => {
        if (video.paused) {
          video.play() // play the video
          btn.innerHTML = '<span aria-hidden="true" class="szicon-pause-button"></span>'
          btn.setAttribute('aria-pressed', 'false')
          btn.setAttribute('aria-label', 'Pause video')
        } else {
          video.pause() // pause the video
          btn.innerHTML = '<span aria-hidden="true" class="szicon-play-button"></span>'
          btn.setAttribute('aria-pressed', 'true')
          btn.setAttribute('aria-label', 'Play video')
        }
      })

      container.appendChild(btn)
    }
  })
})

document.addEventListener('DOMContentLoaded', () => {
  const youtubeIframes = document.querySelectorAll(
    '.content-flow iframe[data-src]'
  );

  function getYouTubeId(url) {
    const match = url.match(/embed\/([^?&/]+)/);
    return match ? match[1] : null;
  }

  function getEmbedUrl(url) {
    const parsed = new URL(url, window.location.origin);
    parsed.searchParams.set('autoplay', '1');
    parsed.searchParams.set('mute', '1');
    parsed.searchParams.set('playsinline', '1');
    parsed.searchParams.set('rel', '0');
    return parsed.toString();
  }

  youtubeIframes.forEach((iframe) => {
    const dataSrc = iframe.dataset.src;
    const title = iframe.getAttribute('title') || 'Video';
    const customThumb = iframe.dataset.thumbnail;
    const videoId = getYouTubeId(dataSrc);

    if (!dataSrc || !videoId) return;

    const fallbackThumb = `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;
    const thumbUrl = customThumb || fallbackThumb;

    const card = document.createElement('div');
    card.className = 'yt-embed-card';

    const previewBtn = document.createElement('button');
    previewBtn.type = 'button';
    previewBtn.className = 'yt-embed-preview';
    previewBtn.setAttribute('aria-label', `Play video: ${title}`);

    previewBtn.innerHTML = `
      <img src="${thumbUrl}" alt="" loading="lazy">
      <span class="yt-embed-play" aria-hidden="true"></span>
    `;

    iframe.parentNode.insertBefore(card, iframe);
    card.appendChild(previewBtn);

    previewBtn.addEventListener('click', () => {
      const activeIframe = document.createElement('iframe');
      activeIframe.src = getEmbedUrl(dataSrc);
      activeIframe.title = title;
      activeIframe.allow =
        iframe.getAttribute('allow') ||
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      activeIframe.referrerPolicy =
        iframe.getAttribute('referrerpolicy') || 'strict-origin-when-cross-origin';
      activeIframe.allowFullscreen = true;

      card.innerHTML = '';
      card.appendChild(activeIframe);
      iframe.remove();
    });
  });
});